import { DrawerObject } from '@/components/drawer/drawer.types';
import { FormBuilderComponent } from '@/components/form-builder/form-builder.component';
import { DynamicForm } from '@/components/form-builder/form-builder.types';
import { DocSubmissionRepository } from '@/store/doc-submission-state/doc-submission-state.repository';

interface IgetDocSubmissionAddDrawerObjectProps {
  store?: DocSubmissionRepository;
  formObject?: DynamicForm;
  toggleVisibility?: () => void;
  action?: () => void;
}

export const getDocSubmissionAddDrawerObject = ({
  store,
  formObject,
  toggleVisibility,
  action,
}: IgetDocSubmissionAddDrawerObjectProps): DrawerObject => {
  return {
    title: 'settings.docSubmission.add.title',
    description: '',
    component: {
      outlet: FormBuilderComponent,
      props: {
        formObject,
      },
    },
    onHide: () => {
      store?.reset();
    },
    actions: [
      {
        label: 'settings.docSubmission.add.add',
        onClick: () => action?.(),
      },
      {
        label: 'settings.docSubmission.add.cancel',
        onClick: () => {
          toggleVisibility?.();
          store?.reset();
        },
        variant: 'secondary',
      },
    ],
  };
};
